"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const react_slick_1 = require("react-slick");
const VirtualTourCard_1 = require("./VirtualTourCard");
const VirtualTourStyle_1 = require("./VirtualTourStyle");
const VirtualTourComponent = ({ classes, content, onClose }) => {
    const settings = {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnDotsHover: true,
        swipeToSlide: true,
        pauseOnFocus: true,
        fade: true
    };
    const interleaveCards = () => {
        const interleavedCards = [];
        content.forEach(item => {
            interleavedCards.push((0, jsx_runtime_1.jsx)(VirtualTourCard_1.default, { item: item, isLast: item.id >= content.length, onClose: onClose }, `slide-${item.id}`));
        });
        return interleavedCards;
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.carouselSection, id: "carousel" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.carouselContainer }, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ container: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12, className: classes.marginAuto }, { children: (0, jsx_runtime_1.jsx)(react_slick_1.default, Object.assign({}, settings, { children: interleaveCards() })) })) })) })) })));
};
exports.default = (0, core_1.withStyles)(VirtualTourStyle_1.default)(VirtualTourComponent);
//# sourceMappingURL=VirtualTourComponent.js.map